import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Camila R.',
    role: 'Mamá emprendedora · Córdoba capital',
    initial: 'C',
    text: 'compre un curso de emprender con budines carísimo el año pasado y no se compara. Acá tenés las recetas, los precios, los mensajes para vender y hasta la calculadora para no perder plata cuando suben los ingredientes. Es todo lo que necesitaba en un solo lugar.'
  }, {
    name: 'Valentina M.',
    role: 'Emprendedora · Mendoza',
    initial: 'V',
    text: 'Llevaba años queriendo emprender y siempre encontraba excusas, que los nenes, que el laburo, que no se que. Con tu ayuda ana hice mi primer frasco un sábado a la mañana y lo vendí ese mismo día por WhatsApp. No lo podía creer. Por menos de lo que sale una pizza te dan todo esto.'
  }, {
    name: 'Luciana T.',
    role: 'Vendedora artesanal · Rosario',
    initial: 'L',
    text: 'Lo que más me sorprendió fueron los bonos. La guía de condimentos italianos y las salsas gourmet son una locura, mis clientes del barrio me piden esas recetas especialmente.'
  }];
  return <section className="py-12 md:py-20 px-4 bg-spice-50" data-id="element-210">
      <div className="max-w-6xl mx-auto" data-id="element-211">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-8 md:mb-16 text-gray-900" data-id="element-212">
          Escucha Lo Que Dicen las chicas que ya se animaron
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8" data-id="element-213">
          {testimonials.map((t, i) => <div key={i} className="bg-white p-5 md:p-8 rounded-2xl shadow-md border border-spice-100 flex flex-col h-full" data-id="element-214">
              <div className="flex text-spice-500 mb-3 md:mb-4" data-id="element-215">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-current" data-id="element-216" />)}
              </div>
              <p className="text-gray-700 italic mb-4 md:mb-8 flex-1 text-base md:text-lg" data-id="element-217">
                "{t.text}"
              </p>
              <div className="flex items-center mt-auto" data-id="element-218">
                <div className="w-12 h-12 bg-spice-200 rounded-full flex items-center justify-center font-heading font-bold text-xl text-spice-800 mr-4" data-id="element-219">
                  {t.initial}
                </div>
                <div data-id="element-220">
                  <p className="font-bold text-gray-900" data-id="element-221">{t.name}</p>
                  <p className="text-sm text-gray-500" data-id="element-222">{t.role}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}